import type { IStatusProps } from 'shared/ui/Status'

type IKeysStatuses = 'disabled' | 'active' | 'unsubscribed' | 'invalid'

const statuses: Record<IKeysStatuses, IStatusProps> = {
  disabled: {
    title: 'Disabled',
    icon: 'minusCircle',
    emphasis: 'high',
    intent: 'neutral',
  },
  active: {
    title: 'Active',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  unsubscribed: {
    title: 'Unsubscribed',
    icon: 'minusCircle',
    emphasis: 'high',
    intent: 'neutral',
  },
  invalid: {
    title: 'Invalid',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
}

export default statuses
